import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Flex, Box } from 'reflexbox';
import {
  Textarea,
  Checkbox,
} from 'rebass';

import { formatPawnFromScaleFactors, keyMap } from 'shared/pawn';

import config from 'frontend/config';
import CopyToClipboard from 'frontend/components/CopyToClipboard';

import actions from 'frontend/state/actions';
import { selectors } from 'frontend/state/reducers/simbot/report';

const PawnDisplay = ({
  charName,
  charClass,
  spec,
  fightStyle,
  date,
  factors,
  includeName,
  includeSpec,
  includeFight,
  includeDate,
  includeClassSpec,

  onClickIncludeName,
  onClickIncludeSpec,
  onClickIncludeFight,
  onClickIncludeDate,
  onClickIncludeClassSpec,
}) => {
  const nameParts = [];
  if (includeName && charName) {
    nameParts.push(charName);
  }
  if (includeSpec && spec) {
    nameParts.push(_.startCase(spec));
  }
  if (includeFight && fightStyle) {
    nameParts.push(fightStyle);
  }
  if (includeDate && date) {
    nameParts.push(`${date.getFullYear()}/${1 + date.getMonth()}/${date.getDate()}`);
  }
  const name = nameParts.join(' - ');
  const scaleName = `${name} (Raidbots)`;
  const value = formatPawnFromScaleFactors(scaleName, charClass, spec, factors, includeClassSpec);

  return (
    <div>
      <Box mb={1}>
        <Textarea
          label="Pawn String"
          name="pawnString"
          rows={4}
          value={value}
          backgroundColor="rgba(255,255,255,.45)"
          readOnly
          mb={0}
        />
        <CopyToClipboard value={value} />
      </Box>
      <Flex wrap>
        <Box col={3}>
          <Checkbox
            name="includeFight"
            label="Name"
            checked={includeName}
            onChange={onClickIncludeName}
            backgroundColor={config.colors.black}
          />
        </Box>
        <Box col={3}>
          <Checkbox
            name="includeFight"
            label="Spec"
            checked={includeSpec}
            onChange={onClickIncludeSpec}
            backgroundColor={config.colors.black}
          />
        </Box>
        <Box col={3}>
          <Checkbox
            name="includeFight"
            label="Fight Style"
            checked={includeFight}
            onChange={onClickIncludeFight}
            backgroundColor={config.colors.black}
          />
        </Box>
        <Box col={3}>
          <Checkbox
            name="includeDate"
            label="Date"
            checked={includeDate}
            onChange={onClickIncludeDate}
            backgroundColor={config.colors.black}
          />
        </Box>
      </Flex>
      <Checkbox
        name="includeClassSpec"
        label="Modern Pawn Format (Class/Spec Metadata)"
        checked={includeClassSpec}
        onChange={onClickIncludeClassSpec}
        backgroundColor={config.colors.black}
      />
    </div>
  );
};

PawnDisplay.propTypes = {
  charName: PropTypes.string.isRequired,
  charClass: PropTypes.string.isRequired,
  spec: PropTypes.string.isRequired,
  fightStyle: PropTypes.string.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  factors: PropTypes.shape(_.mapValues(keyMap, () => PropTypes.number)).isRequired,

  includeName: PropTypes.bool.isRequired,
  includeSpec: PropTypes.bool.isRequired,
  includeFight: PropTypes.bool.isRequired,
  includeDate: PropTypes.bool.isRequired,
  includeClassSpec: PropTypes.bool.isRequired,

  onClickIncludeName: PropTypes.func.isRequired,
  onClickIncludeSpec: PropTypes.func.isRequired,
  onClickIncludeFight: PropTypes.func.isRequired,
  onClickIncludeDate: PropTypes.func.isRequired,
  onClickIncludeClassSpec: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  includeName: selectors.pawnIncludeName(state),
  includeSpec: selectors.pawnIncludeSpec(state),
  includeFight: selectors.pawnIncludeFight(state),
  includeDate: selectors.pawnIncludeDate(state),
  includeClassSpec: selectors.pawnIncludeClass(state),
});

const mapDispatchToProps = {
  onClickIncludeName: actions.toggleReportPawnName,
  onClickIncludeSpec: actions.toggleReportPawnSpec,
  onClickIncludeFight: actions.toggleReportPawnFight,
  onClickIncludeDate: actions.toggleReportPawnDate,
  onClickIncludeClassSpec: actions.toggleReportPawnClass,
};

export default connect(mapStateToProps, mapDispatchToProps)(PawnDisplay);
